import { api, useApi } from '../api/queries'
import type { BanReplay } from '../api/types'
import { UniverseConstructorPage, UniverseDriverPage } from './PeoplePages'
import { UniverseRacePage } from './RacePage'
import {
  ReplayChampionshipPage,
  ReplayConstructorsPage,
  ReplayDriversPage,
  ReplaySeasonPage,
  universeOf,
  type Source,
} from './ReplayPages'

/** The scale the server reads as the FP Championship. */
const SCALE = 'practice'

const PRACTICE: Source = {
  path: '/fp',
  suffix: 'in free practice',
  use: function usePracticeSource() {
    const replay = useApi<BanReplay>(['scale', SCALE], () =>
      api.GET('/api/v1/scale', { params: { query: { scale: SCALE } } }),
    )
    return {
      chosen: true,
      search: '',
      replay,
      summary: (
        <p className="prose muted">
          Only free practice scores. Every session is a Grand Prix of its own, scored on that
          season’s race table: the fastest driver wins it, and a weekend with three sessions
          hands out three wins. Every result counts and no round is worth more than another.
          From 1988, the first season f1db times every Friday.
        </p>
      ),
      seasonQuery: () => ({ scale: SCALE }),
      driverSeasons: (slug) => [
        ['scale', 'driver-seasons', slug, SCALE],
        () =>
          api.GET('/api/v1/scale/drivers/{slug}/seasons', {
            params: { path: { slug }, query: { scale: SCALE } },
          }),
      ],
    }
  },
}

export const PracticeChampionshipPage = () => <ReplayChampionshipPage source={PRACTICE} />
export const PracticeDriversPage = () => <ReplayDriversPage source={PRACTICE} />
export const PracticeConstructorsPage = () => <ReplayConstructorsPage source={PRACTICE} />
export const PracticeSeasonPage = () => <ReplaySeasonPage source={PRACTICE} />

const PRACTICE_UNIVERSE = universeOf(PRACTICE)
export const PracticeDriverPage = () => <UniverseDriverPage universe={PRACTICE_UNIVERSE} />
export const PracticeConstructorPage = () => (
  <UniverseConstructorPage universe={PRACTICE_UNIVERSE} />
)
export const PracticeRacePage = () => <UniverseRacePage universe={PRACTICE_UNIVERSE} />
